import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, unref as _unref, resolveComponent as _resolveComponent, createVNode as _createVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, withCtx as _withCtx, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode } from "vue"

const _hoisted_1 = { class: "stats-sidebar" }
const _hoisted_2 = { class: "stats-header" }
const _hoisted_3 = { class: "stats-cards" }
const _hoisted_4 = { class: "stat-card" }
const _hoisted_5 = { class: "stat-icon" }
const _hoisted_6 = { class: "stat-content" }
const _hoisted_7 = { class: "stat-value" }
const _hoisted_8 = { class: "stat-card" }
const _hoisted_9 = { class: "stat-content" }
const _hoisted_10 = { class: "stat-value" }
const _hoisted_11 = { class: "stat-card" }
const _hoisted_12 = { class: "stat-content" }
const _hoisted_13 = { class: "stat-value" }
const _hoisted_14 = { class: "stat-card" }
const _hoisted_15 = { class: "stat-content" }
const _hoisted_16 = { class: "stat-value" }
const _hoisted_17 = {
  key: 0,
  class: "stats-error"
}

import { useStatsStore } from '../stores/statsStore'
import { useWorkspaceStore } from '../stores/workspaceStore'


export default /*@__PURE__*/_defineComponent({
  __name: 'StatsSidebar',
  setup(__props, { expose: __expose }) {

const { stats, loading, error, fetchStats, refreshStats } = useStatsStore()
const { getWorkspaceEmoji } = useWorkspaceStore()
const workspaceEmoji = getWorkspaceEmoji()

// Expose refresh function for parent components
__expose({
  refresh: refreshStats
})

return (_ctx: any,_cache: any) => {
  const _component_v_btn = _resolveComponent("v-btn")!
  const _component_v_alert = _resolveComponent("v-alert")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _cache[0] || (_cache[0] = _createElementVNode("h3", null, "Your Stats", -1)),
      _createVNode(_component_v_btn, {
        icon: "mdi-refresh",
        size: "small",
        variant: "text",
        loading: _unref(loading),
        onClick: _unref(refreshStats),
        title: "Refresh stats"
      }, null, 8, ["loading", "onClick"])
    ]),
    _createElementVNode("div", _hoisted_3, [
      _createElementVNode("div", _hoisted_4, [
        _createElementVNode("div", _hoisted_5, _toDisplayString(_unref(workspaceEmoji).emojiSymbol), 1),
        _createElementVNode("div", _hoisted_6, [
          _cache[1] || (_cache[1] = _createElementVNode("h4", null, "Total Received", -1)),
          _createElementVNode("div", _hoisted_7, _toDisplayString(_unref(stats).points), 1)
        ])
      ]),
      _createElementVNode("div", _hoisted_8, [
        _cache[3] || (_cache[3] = _createElementVNode("div", { class: "stat-icon" }, "📊", -1)),
        _createElementVNode("div", _hoisted_9, [
          _cache[2] || (_cache[2] = _createElementVNode("h4", null, "Total Given", -1)),
          _createElementVNode("div", _hoisted_10, _toDisplayString(_unref(stats).pointsGiven || '-'), 1)
        ])
      ]),
      _createElementVNode("div", _hoisted_11, [
        _cache[5] || (_cache[5] = _createElementVNode("div", { class: "stat-icon" }, "🎁", -1)),
        _createElementVNode("div", _hoisted_12, [
          _cache[4] || (_cache[4] = _createElementVNode("h4", null, "Redeemable", -1)),
          _createElementVNode("div", _hoisted_13, _toDisplayString(_unref(stats).redeemablePoints), 1)
        ])
      ]),
      _createElementVNode("div", _hoisted_14, [
        _cache[7] || (_cache[7] = _createElementVNode("div", { class: "stat-icon" }, "⭐", -1)),
        _createElementVNode("div", _hoisted_15, [
          _cache[6] || (_cache[6] = _createElementVNode("h4", null, "Rank", -1)),
          _createElementVNode("div", _hoisted_16, _toDisplayString(_unref(stats).rank || '-'), 1)
        ])
      ])
    ]),
    (_unref(error))
      ? (_openBlock(), _createElementBlock("div", _hoisted_17, [
          _createVNode(_component_v_alert, {
            type: "error",
            variant: "tonal",
            density: "compact"
          }, {
            default: _withCtx(() => [
              _createTextVNode(_toDisplayString(_unref(error)), 1)
            ]),
            _: 1
          })
        ]))
      : _createCommentVNode("", true)
  ]))
}
}

})